import * as React from "react";
import * as _ from "lodash";
import "./style.scss";
import Button from "../../../../core/Button";
import { Icon } from "antd";
import { AnalyticsGlobalFilters } from "../../../constants";

export namespace GlobalFilterButton {
  export interface Props {
    globalFilters: AnalyticsGlobalFilters;
    onMouseEnter?: any;
    onMouseLeave?: any;
    onFocus?: any;
    onClick?: any;
  }
}

export const GlobalFilterButton = (props: GlobalFilterButton.Props): any => {
  const renderFilterText = () => {
    const {
      globalFilters: { device, channel }
    } = props;
    const devices: string[] = _.uniq(device);
    const channels: string[] = _.uniq(channel);
    let channelText = "";
    let deviceText = "";

    switch (devices.length) {
      case 2:
        deviceText = "All Devices";
        break;
      case 1:
        deviceText = _.capitalize(devices[0]);
        break;
      default:
        deviceText = "No Devices";
        break;
    }
    switch (channels.length) {
      case 2:
        channelText = "All Channels";
        break;
      case 1:
        channelText = _.startCase(_.camelCase(channels[0]));
        break;
      default:
        channelText = "No Channels";
        break;
    }

    if (channelText === "Distribution") {
      channelText = "Flipp Network";
    }
    return `${channelText},  ${deviceText}`;
  };

  return (
    <Button
      className="global-filter-button"
      onClick={props.onClick}
      data-automation-id={"global-filter-button"}
    >
      <div className="left-section" id="global-filter-text">
        <div className="global-filter-button-title">FILTERS</div>
        <div
          className="global-filter-text"
          data-automation-id={"global-filter-text"}
        >
          {renderFilterText()}
        </div>
      </div>
      <div className="right-section">
        <div className="menu-divider" />
        <Icon type="caret-down" style={{ color: "#428CE8" }} />
      </div>
    </Button>
  );
};



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/common/GlobalFilterButton/index.tsx